"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const react_native_in_app_review_1 = __importDefault(require("react-native-in-app-review"));
const theme_1 = __importDefault(require("../../styles/theme"));
const labelButton_1 = __importDefault(require("../labelButton/labelButton"));
const analytics_1 = require("../../utils/analytics/analytics");
const constants_1 = require("../../constants/constants");
const homeSlice_1 = require("../../features/home/homeSlice");
const store_1 = require("../../store");
const text_1 = __importStar(require("../text/text"));
const styles_1 = __importDefault(require("../../styles/styles"));
const modal_1 = __importDefault(require("../modal/modal"));
const textStyles_1 = __importDefault(require("../text/textStyles"));
const primaryButton_1 = __importDefault(require("../primaryButton/primaryButton"));
const shareExperienceStyles_1 = __importDefault(require("./shareExperienceStyles"));
const ShareExperienceModals = ({ closeModal, closeAfterModal, userChosenRating, isModalVisible, isAfterModalVisible, reviewNumber, eventName, }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const screenWidth = react_native_1.Dimensions.get('screen').width;
    const [displayGoogleReview, setDisplayGoogleReview] = (0, react_1.useState)(true);
    // SUBMIT FORM DATA
    const submitForm = async (userRating) => {
        const payload = {
            user_rating: userRating,
        };
        dispatch((0, homeSlice_1.submitUserRating)(payload));
    };
    const userSubmitRating = (review, openGoogleRating) => {
        logEventWithExtraProperties('tap_event', {
            name: 'submit_app_rating',
            rating: review,
        });
        // mark as review done and exit
        submitForm(review);
        // positive rating
        if (review > 3 && review <= 5) {
            // Web google rating goes to store url with button on modal (only for web)
            if (openGoogleRating) {
                if (react_native_1.Platform.OS === 'web') {
                    react_native_1.Linking.openURL(constants_1.PLAY_STORE_URL);
                }
            }
            /* GOOGLE IN APP REVIEW */
            if (react_native_1.Platform.OS !== 'web' && displayGoogleReview && react_native_in_app_review_1.default.isAvailable()) {
                // If available this triggers the in-App review
                // trigger UI InAppreview
                react_native_in_app_review_1.default.RequestInAppReview()
                    .then((hasFlowFinishedSuccessfully) => {
                    if (hasFlowFinishedSuccessfully) {
                        // This should not be necessary, just to make sure it doesn't appear multiple times
                        setDisplayGoogleReview(false);
                    }
                })
                    .catch((error) => {
                    // If in app review is not available for a users phone or it had an error use store link
                    if (error || !react_native_in_app_review_1.default.isAvailable()) {
                        react_native_1.Linking.openURL(constants_1.PLAY_STORE_URL);
                    }
                });
            }
        }
        closeAfterModal();
    };
    const ratingData = [
        {
            value: 1,
            label: 'I hated \nit!',
        },
        {
            value: 2,
            label: "I didn't like it!",
        },
        // COMMENTED CAUSE THIS IS GOING TO CHANGE
        // {
        //     value: 3,
        //     label: 'It was ok.'
        // },
        {
            value: 4,
            label: 'I liked it!',
        },
        {
            value: 5,
            label: 'I loved it!',
        },
    ];
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(modal_1.default, { showModal: isModalVisible, dismissModal: closeModal },
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, biggerSubtitle: true, style: textStyles_1.default.bold }, t('shareExperienceModal.how_was_it')),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.minimumMarginBetweenElementsVertically] }, ratingData.map((value) => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_native_1.View, { style: { marginRight: 2 } }),
                react_1.default.createElement(primaryButton_1.default, { title: value.label, onPress: () => userChosenRating(value.value), eventName: eventName })))))),
        react_1.default.createElement(modal_1.default, { showModal: isAfterModalVisible, dismissModal: closeAfterModal },
            react_1.default.createElement(react_native_1.View, { style: [
                    styles_1.default.centerChildHorizontalVertical,
                    react_native_1.Platform.OS === 'web' && screenWidth > constants_1.BREAK_POINT_WIDTH ? null : shareExperienceStyles_1.default.flexThreeStart,
                ] }, reviewNumber <= 3 && reviewNumber >= 1 ? (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE }, t('shareExperienceModal.thanks_feedback'))) : (react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE, style: textStyles_1.default.bold }, t('shareExperienceModal.thanks_feedback')),
                react_native_1.Platform.OS === 'web' ? (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('shareExperienceModal.install_app'))) : (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('shareExperienceModal.recommend')))))),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.centerChildHorizontalVertical] }, reviewNumber <= 3 && reviewNumber >= 1 ? (react_1.default.createElement(labelButton_1.default, { title: "CLOSE", textColor: theme_1.default.colors.COLOR_GREEN_DARK, onPress: () => userSubmitRating(reviewNumber, false), disabled: false, eventName: "close_share_experience_modal" })) : (react_1.default.createElement(react_native_1.View, { style: [
                    styles_1.default.flexOne,
                    styles_1.default.flexDirectionRow,
                    styles_1.default.centerChildHorizontalVertical,
                ] },
                react_1.default.createElement(labelButton_1.default, { title: "CLOSE", textColor: theme_1.default.colors.COLOR_GRAY_DARK, onPress: () => userSubmitRating(reviewNumber, false), disabled: false, eventName: "close_share_experience_modal" }),
                react_native_1.Platform.OS === 'web' && (react_1.default.createElement(labelButton_1.default, { title: "GO TO STORE", textColor: theme_1.default.colors.COLOR_GREEN_DARK, onPress: () => userSubmitRating(reviewNumber, true), disabled: false, eventName: "navigate_app_store" }))))))));
};
exports.default = ShareExperienceModals;
